import { useQuery } from 'react-query'

import { impactsLibraryService } from 'src/services'

import { IFilter } from 'src/components/filter/types/filter.types'
import { removeDefaultParams } from 'src/common/utils'
import { QUERY_KEYS } from 'src/constants'

const initialLibraryImpactsFilterValues = { query: '', type: 'all', unSdg: 'all' }

const useLibraryImpacts = (filter?: IFilter) => {
  return useQuery(
    [QUERY_KEYS.WHITE_LABEL_PARTNERS, filter ?? ''],
    () => {
      if (filter) {
        return impactsLibraryService.getFilteredLibraryImpacts(
          removeDefaultParams(filter, initialLibraryImpactsFilterValues),
        )
      }

      return impactsLibraryService.getLibraryImpacts()
    },
    {
      keepPreviousData: true,
    },
  )
}

export { useLibraryImpacts, initialLibraryImpactsFilterValues }
